/**
* Component: historicalCostReducer.js
* Description: This reducer is used for the Historical Cost Maintainance Details
*/

//To Set the initial state for the historical cost reducer
const initialState = {
    historicalmaintenanceyear:{},
    breakdowncost:'',
    ppmcost:'',
    totalmaintenancecost:'',
};

const historicalCostReducer =  (state = initialState, action) => {
  switch (action.type) {
    case "NEW_HISTORICAL_COST_DATA":
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};
  
  export default historicalCostReducer;